<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <template>
            <a-col :md="8" :sm="12">
              <a-form-item :label="$t(I18N_KEY + 'dataDate')">
                <a-range-picker v-model="queryParam.createdTime" format="YYYY-MM-DD" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="10" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'type')">
              <a-select v-model="queryParam.type" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in types' :key='item.value'>
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 1500 }"
        bordered>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
    </div>
  </div>
</template>
<script>
import { dataNumList, dataNumBaseData } from '@/webpublicapi/teleMarket'
import {mapGetters} from "vuex";
import { filterObj } from '@/utils/util'
import moment from 'moment/moment'
const I18N_KEY = 'teleMarket.';
export default {
  name: 'TeleMarketDataNum',
  data () {
    return {
      I18N_KEY,
      loading: false,
      allowClear: true,
      total: 0,
      types: [],
      statuses: [],
      fieldName: 'textCn',
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        type: [],
        createdTime: [],
      },
      visible: false,
      dataSource: [],
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    // Table header
    columns () {
      return [
        {
          title: this.$t(I18N_KEY + 'id'),
          dataIndex: 'id',
          align:"center",
          width:80,
        },
        {
          title: this.$t(I18N_KEY + 'dataDate'),
          dataIndex: 'dataDate',
          width:100,
          align:"center",
        },
        {
          title: this.$t(I18N_KEY + 'type'),
          align: 'center',
          width: 200,
          dataIndex: 'type',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.types) {
                if(text === this.types[i].value) {
                  return this.types[i][this.fieldName]
                }
              }
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'param'),
          dataIndex: 'param',
          align:"center",
          width:100,
        },
        // {
        //   title: this.$t(I18N_KEY + 'registerStartDate'),
        //   dataIndex: 'registerStartTime',
        //   width:170,
        //   align:"center",
        // },
        // {
        //   title: this.$t(I18N_KEY + 'registerEndDate'),
        //   dataIndex: 'registerEndTime',
        //   width:170,
        //   align:"center",
        // },
        {
          title: this.$t(I18N_KEY + 'app'),
          align: 'center',
          dataIndex: 'appssids',
          width:150,
        },
        {
          title: this.$t(I18N_KEY + 'totalNum'),
          align:"center",
          dataIndex: 'totalNum',
          width:100,
        },
        {
          title: this.$t(I18N_KEY + 'totalNumNew'),
          align:"center",
          dataIndex: 'totalNumNew',
          width:100,
        },
        {
          title: this.$t(I18N_KEY + 'assignNum'),
          align:"center",
          dataIndex: 'assignNum',
          width:100,
        },
        {
          title: this.$t(I18N_KEY + 'noAssignNum'),
          align:"center",
          dataIndex: 'noAssignNum',
          width:100,
        },
        {
          title: this.$t(I18N_KEY + 'param'),
          align:"center",
          dataIndex: 'jsonParam',
          ellipsis: true,
        },
        {
          title: this.$t(I18N_KEY + 'createTime'),
          align:"center",
          width:170,
          dataIndex: 'createTime',
        },
        {
          title: this.$t(I18N_KEY + 'updateTime'),
          align:"center",
          width:170,
          dataIndex: 'updateTime',
        }]
    },
  },
  created () {
    this.loadBaseData();
    this.loadData('');
  },
  methods: {
    loadBaseData(){
      dataNumBaseData({}).then((res) => {
        if (res.code === 1000) {
          this.types = res.data.types
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    searchQuery () {
      this.loadData(1)
    },
    handleTableChange (pageNum, pageSize) {
      this.queryParam.pageNum = pageNum;
      this.queryParam.pageSize = pageSize;
      this.loadData();
    },
    modalFormOk(data) {
      this.createSeat(data);
    },
    handleAdd () {
      this.versionId = undefined;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "1";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit (record) {
      this.versionId = record.id;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "2";
      this.$refs.modalForm.disableSubmit = false;
    },
    changeModal (visible) {
      this.visible = visible;
    },
    searchReset () {
      // this.createdTime = []
      this.queryParam.pageNum=1
      this.queryParam.pageSize=10
      this.queryParam.type=[]
      this.queryParam.createdTime=[]
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: createdTime && this.transformTime(createdTime[0]),
        endDate: createdTime && this.transformTime(createdTime[1]),
      }
      if(this.queryParam.createdTime.length === 0) {
        data['startDate'] = ''
        data['endDate']=''
      }
      var param = Object.assign({}, data)
      // param.pageNum = this.form.pageNum
      // param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    loadData (pageNum) {
      if(pageNum) { this.queryParam.pageNum = pageNum; }
      this.loading = true;
      var params = this.getQueryParams()// Query conditions
      dataNumList(Object.assign({}, params)).then(res => {
        this.loading = false;
        this.total = res.data.total
        this.dataSource = res.data.rows;
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    statusText(status) {
      for(var i in this.statuses) {
        if(status === this.statuses[i].value) {
          return this.statuses[i][this.fieldName]
        }
      }
    },
  },
  watch: {
    languageStorage: {
      handler (lang) {
        if (lang == 'en-US') {
          this.fieldName = 'textEn';
        } else if (lang == 'es') {
          this.fieldName = 'textEs';
        } else {
          this.fieldName = 'textEn';
        }
      },
      immediate: true,
    }
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
